import { useUnread } from "@/contexts/UnreadContext";
import type { SidebarUnreadMaps } from "@/hooks/useUnreadNotifications";

export type { SidebarChannel, SidebarUnreadMaps } from "@/hooks/useUnreadNotifications";
export { EMPTY_SIDEBAR_UNREADS } from "@/hooks/useUnreadNotifications";

/**
 * Badges da sidebar — mesma fonte de verdade do header (UnreadContext / useUnreadNotifications).
 * Sem SELECT próprio nem subscription realtime adicional.
 */
export function useSidebarConversationUnreads(_workspaceId: string | null): SidebarUnreadMaps {
  return useUnread().sidebarUnreads;
}
